import './style.scss'
import React, { useState, useEffect } from 'react'
import DataTable from 'react-data-table-component';
import { customStyles } from './style'
import { AppText, FlexColumn, GridContainer } from 'src/style';
import {ReactComponent as NoDataIcon} from 'src/assets/svg/no-data-icon.svg'

export const Table: React.FC<any> = React.memo(({
    tableData, tableColumns, resetPagination, 
    hasRowSelection, onRowSelectedMethod,
    onRowClickMethod, noDataText,
    paginationPerPage, noDataCustomIcon, actionComponent
}) => {
    const [mockTableData, setMockTableData] = useState<any[]>([])

    useEffect(() => {
        setMockTableData(tableData)
    }, [tableData])


    return (
        <>
        { tableData ?
                <>
                    <div>
                        <DataTable
                            columns={tableColumns}
                            data={mockTableData?.length ? mockTableData : tableData}
                            paginationResetDefaultPage={resetPagination}
                            //striped={true}
                            onRowClicked={onRowClickMethod}
                            selectableRows={hasRowSelection}
                            onSelectedRowsChange={hasRowSelection ? onRowSelectedMethod : () => null}
                            pagination
                            paginationPerPage={paginationPerPage || 10}
                            customStyles={customStyles}
                            noDataComponent={
                                <NoTableData 
                                    noDataText={noDataText} 
                                    actionComponent={actionComponent} 
                                    noDataCustomIcon={noDataCustomIcon}
                                />
                            }
                        />
                    </div>
                </>
                : 
                <NoTableData 
                    noDataText={noDataText} 
                    actionComponent={actionComponent}
                    noDataCustomIcon={noDataCustomIcon}
                />
            }
        </>
    )
})

export const NoTableData: React.FC<any> = ({noDataText, noDataCustomIcon, actionComponent}) => {
    return (
        <GridContainer 
            height='100' hUnit='%'
        >
            <FlexColumn width="auto" sizeUnit="">
                { noDataCustomIcon ?
                    noDataCustomIcon
                    :
                    <NoDataIcon className="icon-component" />
                }
                <AppText textSize="1.6" fontWeight="600" color="#101828" align="center" topMargin="1.5">
                    {noDataText || 'No Records'}
                </AppText>
                {actionComponent && actionComponent}
            </FlexColumn>
        </GridContainer>
    )
}